<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

<ng-template #default let-item>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #rechteId let-item>
  <ng-container>{{ getAbkuerzungKey(item.art) | translate }}</ng-container>
  <ng-container> {{ item.rechteId | formatRechteId }}</ng-container>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #common>
  @if (version.stichwort && version.stichwortZusatz && appformatConfigService.parameterConfig$ | async; as config) {
    @if (config.parameters.STICHWORT_ANZEIGEN_DRUCKEN) {
      {{ version.stichwort?.text | translateName }}
    }
  }
  @if (version.stichwort && !version.stichwortZusatz) {
    {{ version.stichwort?.text | translateName }}
  }
  @if (version.stichwortZusatz) {
    {{ version.stichwortZusatz }}
  }
  @if (version.wert > 0) {
    , CHF {{ version.wert | betrag }}
  }
  @if (version.ablaufdatum) {
    , {{ "bis" | translate }} {{ version.ablaufdatum | datum }}
  }
</ng-template>
